import { render, staticRenderFns } from "./ProdesResiduos.vue?vue&type=template&id=2d249b17&lang=pug"
import script from "./ProdesResiduos.vue?vue&type=script&lang=js"
export * from "./ProdesResiduos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports